module.exports = __webpack_public_path__ + "img/kafka.4f241bdf.svg";